// A conversation the web app asks to open: one its Scenario Home lists, or the one a notification is
// about. Only the person's own conversations: their general ones, or, over a loan, theirs on that
// loan. The server checks ownership from the id too.
const OWN_THREAD_TAIL_PATTERN = /^(:[A-Za-z0-9_.:-]{1,200})?$/;

export const readOpenThreadId = (value, { organizationId, userId, loanId = null }) => {
  if (typeof value !== "string" || !organizationId || !userId) {
    return null;
  }

  const ownPrefix = loanId ? `loan:${organizationId}:${userId}:${loanId}` : `general:${organizationId}:${userId}`;

  return value.startsWith(ownPrefix) && OWN_THREAD_TAIL_PATTERN.test(value.slice(ownPrefix.length))
    ? value
    : null;
};
